import EyeOutlined from '@ant-design/icons/EyeOutlined'
import FileExcelOutlined from '@ant-design/icons/FileExcelOutlined'
import FileImageOutlined from '@ant-design/icons/FileImageOutlined'
import FilePdfOutlined from '@ant-design/icons/FilePdfOutlined'
import FileTextOutlined from '@ant-design/icons/FileTextOutlined'
import FileWordOutlined from '@ant-design/icons/FileWordOutlined'
import FileZipOutlined from '@ant-design/icons/FileZipOutlined'
import { Tooltip } from 'antd'
import uniqBy from 'lodash/uniqBy'
import { inject, observer } from 'mobx-react'
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { blue, green, purple9, redPrimary } from '../../../color'
import TableComponent from '../../../components/Common/TableComponent'
import FileViewPopup from '../../../components/FileViewPopup'
import fileStore from '../../../stores/fileStore'
import utils from '../../../utils'

const FileTableWrapper = styled.div`
  .view-icon {
    color: ${green};
    padding: 3px 8px;
    height: 18px;
    transform: translateY(1px);
    border-radius: 4px;
    margin-left: 4px;

    &:hover {
      background-color: #f0f0f0;
    }
  }
`

const getFileIcon = file_type => {
  const iconMap = {
    pdf: <FilePdfOutlined style={{ color: redPrimary }} />,
    doc: <FileWordOutlined style={{ color: blue }} />,
    docx: <FileWordOutlined style={{ color: blue }} />,
    jpg: <FileImageOutlined style={{ color: purple9 }} />,
    bmp: <FileImageOutlined style={{ color: purple9 }} />,
    dib: <FileImageOutlined style={{ color: purple9 }} />,
    jpe: <FileImageOutlined style={{ color: purple9 }} />,
    jfif: <FileImageOutlined style={{ color: purple9 }} />,
    gif: <FileImageOutlined style={{ color: purple9 }} />,
    tif: <FileImageOutlined style={{ color: purple9 }} />,
    tiff: <FileImageOutlined style={{ color: purple9 }} />,
    png: <FileImageOutlined style={{ color: purple9 }} />,
    heic: <FileImageOutlined style={{ color: purple9 }} />,
    rar: <FileZipOutlined style={{ color: '#e67e22' }} />,
    zip: <FileZipOutlined style={{ color: '#e67e22' }} />,
    xlsx: <FileExcelOutlined style={{ color: green }} />,
    xls: <FileExcelOutlined style={{ color: green }} />,
  }
  return iconMap[file_type] || <FileTextOutlined />
}

const TableFileItem = props => {
  const { listHistoryLogStore, code } = props
  const { historyLists } = listHistoryLogStore
  const [isVisibleFileViewPopup, setIsVisibleFileViewPopup] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)

  const filtered = historyLists.filter(
    item => item.file_id !== null && item.file_name !== null
  )
  const uniqueFileIds = uniqBy(filtered, 'file_id')

  useEffect(() => {
    ;(async () => {
      await listHistoryLogStore.getLists(code)
    })()
  }, [code])

  const handleDownload = useCallback(
    record => {
      if (record.noAction || record.deleted) return
      if (record.isFileVIMCToTruc)
        return fileStore.handleDownloadAttachmentTruc(
          record.file_id,
          record.file_name
        )
      if (record.isFileTruc)
        return fileStore.handleDownloadFileTruc(
          record.file_id,
          record.file_name
        )
      return fileStore.handleDownloadFile(record.file_id, record.file_name)
    },
    [fileStore]
  )

  const columns = useMemo(
    () => [
      {
        title: 'STT',
        render: (_, record, index) => index + 1,
      },
      {
        title: 'Tên file',
        dataIndex: 'file_name',
        key: 'file_name',
        render: (text, record) => {
          const fileExtension = text.split('.').pop().toLowerCase()
          return (
            <Tooltip title="Tải xuống">
              <span
                style={{ color: blue, cursor: 'pointer' }}
                onClick={() => handleDownload(record)}
                className="file-item">
                {getFileIcon(fileExtension)} {text}
              </span>
            </Tooltip>
          )
        },
      },
      {
        title: 'Người gửi',
        key: 'user',
        render: (_, record) =>
          record.user && record.user.name_uppercase
            ? utils.getNameInCapitalize(record.user.name_uppercase)
            : 'Unknown',
      },
      {
        title: 'Thời gian tạo',
        key: 'processed_date',
        render: (_, record) => {
          const date = new Date(record.processed_date)
          return (
            `${String(date.getDate()).padStart(2, '0')}-` +
            `${String(date.getMonth() + 1).padStart(2, '0')}-` +
            `${date.getFullYear()} ` +
            `${String(date.getHours()).padStart(2, '0')}:` +
            `${String(date.getMinutes()).padStart(2, '0')}:` +
            `${String(date.getSeconds()).padStart(2, '0')}`
          )
        },
      },
      {
        title: 'Thao tác',
        key: 'action',
        render: (_, record) => (
          <Tooltip title="Xem tài liệu">
            <EyeOutlined
              className="view-icon"
              style={{ color: green, cursor: 'pointer', fontSize: '18px' }}
              onClick={() => {
                setSelectedFile(record)
                setIsVisibleFileViewPopup(true)
              }}
            />
          </Tooltip>
        ),
      },
    ],
    [handleDownload, setSelectedFile, setIsVisibleFileViewPopup]
  )

  return (
    <FileTableWrapper>
      <TableComponent
        columns={columns}
        dataSource={uniqueFileIds || []}
        rowKey="file_id"
        pagination={false}
      />
      {selectedFile && (
        <FileViewPopup
          file={{
            file_name: selectedFile.file_name,
            file_id: selectedFile.file_id,
          }}
          isVisibleFileViewPopup={isVisibleFileViewPopup}
          handleCloseFileViewPopup={() => setIsVisibleFileViewPopup(false)}
        />
      )}
    </FileTableWrapper>
  )
}

export default memo(
  inject(
    'listHistoryLogStore',
    'userStore',
    'loadingAnimationStore'
  )(observer(TableFileItem))
)
